import { render, staticRenderFns } from "./BriqRichEditorLinkPopup.vue?vue&type=template&id=01758620&scoped=true&lang=pug&"
import script from "./BriqRichEditorLinkPopup.vue?vue&type=script&lang=js&"
export * from "./BriqRichEditorLinkPopup.vue?vue&type=script&lang=js&"
import style0 from "./BriqRichEditorLinkPopup.vue?vue&type=style&index=0&id=01758620&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01758620",
  null
  
)

export default component.exports